// Shared answer-card colors. Layout and answer-state logic stay in each view.
export const CHOICE_TONES = Object.freeze([
  Object.freeze({ bg: '#F7F2FF', border: '#CDAEFF' }),
  Object.freeze({ bg: '#EFF7FF', border: '#B3D4FF' }),
  Object.freeze({ bg: '#FFF3E8', border: '#F5BD91' }),
  Object.freeze({ bg: '#fff7db', border: '#f8c66a' }),
]);

export const CHOICE_FEEDBACK = Object.freeze({
  correct: Object.freeze({
    bg: '#ecfdf3',
    border: '#22c55e',
    text: '#15803d',
    shadow: '0 8px 0 rgba(34,197,94,0.18), 0 16px 28px rgba(34,197,94,0.18)',
  }),
  wrong: Object.freeze({ bg: '#fff1f2', border: '#fb7185' }),
});
